import styled from "styled-components";
import { Attribute, AttributeGroup, AttributeProperty, ComponentProps, ContainerAttributes } from "react-builder";
import { RegistrationContext, SignupStage } from "./LandingPage";
import { useContext } from "react";

@AttributeGroup({ title: 'SignupStageContainer', blockName: 'SignupStageContainer' })
export class SignupStageContainerAttributes extends Attribute {

    @AttributeProperty({ type: 'Select', selectOptions: Object.values(SignupStage) })
    stage: SignupStage = SignupStage.signup;

    @AttributeProperty({ type: 'Object', cssTarget: '.SignupStageContainer' })
    container: ContainerAttributes = new ContainerAttributes()
}

const SignupStageContainerTheme = styled.div((props: { attributes: SignupStageContainerAttributes }) => `

    ${props.attributes.toCSS()}

    &:not(.show):not(.is-selected):not(.has-child-selected){
        display: none !important;
    }

`);

export function SignupStageContainer(props: ComponentProps<SignupStageContainerAttributes>) {

    const regCtx = useContext(RegistrationContext);

    return (
        <SignupStageContainerTheme attributes={props.attributes} className={`SignupStageContainer ${props.className} ${regCtx.state == props.attributes.stage ? 'show' : 'hide'}`}>
            {props.children}
        </SignupStageContainerTheme>
    )
}


SignupStageContainer.prototype.Props = SignupStageContainerAttributes;


export default SignupStageContainer;